import React from "react";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

function Header() {
  const [mobile, setMobile] = useState(false);

  useEffect(() => {
    setMobile(false);
  },[useParams()])

  return (
    <header>
      <a href="/" id="logo">
        <h1><img src="/image/hd_logo.svg" alt=""></img></h1>
      </a>

      <nav id="menu">

        <ul className="pc">
          <li><Link to="/about">회사소개</Link></li>
          <li><Link to="/service">서비스 안내</Link></li>
          <li><Link to="/portfolio/All">포트폴리오</Link></li>
          <li><Link to="/contact">문의하기</Link></li>
        </ul>

        <div className="mobile">
          <div className="button" onClick={()=>{setMobile(!mobile)}}>
            <i class="fa-solid fa-bars"></i>
          </div>

          <ul className={mobile === false ? "" : "on"}>
            <li><Link to="/about">회사소개</Link></li>
            <li><Link to="/service">서비스 안내</Link></li>
            <li><Link to="/portfolio/All">포트폴리오</Link></li>
            <li><Link to="/contact">문의하기</Link></li>
          </ul>

          <div
            className={mobile === false ? "bg" : "bg on"}
            onClick={()=>{setMobile(false)}}
          ></div>
        </div>

      </nav>
    </header>
  );
}

export default Header;
